(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centered-menu"] && !Shopify.designMode) return;
  try {
    
/* Submenu toggles for touch/click; no jQuery */
(function(){
  const root = document.getElementById('CenteredMenu-{{ section.id }}');
  if (!root) return;

  const items = root.querySelectorAll('.cnav__item.has-children');

  function setExpanded(el, on){
    if (!el) return;
    el.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  items.forEach(function(item){
    const toggle = item.querySelector('.cnav__toggle');
    const link   = item.querySelector('.cnav__link');

    function open(){
      item.classList.add('is-open');
      setExpanded(toggle, true);
      setExpanded(link, true);
    }
    function close(){
      item.classList.remove('is-open');
      setExpanded(toggle, false);
      setExpanded(link, false);
    }

    if (toggle){
      toggle.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        item.classList.contains('is-open') ? close() : open();
        requestAnimationFrame(()=> clampMenu(item)); // clamp when toggled
      });
    }

    document.addEventListener('click', function(e){
      if (!item.contains(e.target)) close();
    });

    item.addEventListener('keydown', function(e){
      if (e.key === 'Escape'){ close(); link && link.focus(); }
    });

    item.addEventListener('mouseenter', ()=> clampMenu(item));
    item.addEventListener('focusin',   ()=> clampMenu(item));
  });
})();

/* Robust viewport clamping using inline styles (wins over open-state CSS) */
(function(){
  const root  = document.getElementById('CenteredMenu-{{ section.id }}');
  if (!root) return;

  const PAD = 16; // keep at least 16px from viewport edge

  window.clampMenu = function(item){
    const menu = item.querySelector('.cnav__submenu');
    if (!menu) return;

    // Reset to default (centered) before measurement
    menu.style.left = '';
    menu.style.right = '';
    menu.style.transform = '';

    // If currently hidden, reveal just for measurement without flashing
    const wasHidden = getComputedStyle(menu).visibility === 'hidden';
    if (wasHidden){
      menu.style.visibility = 'hidden';
      menu.style.opacity = '1';
      menu.style.pointerEvents = 'none';
      menu.style.transform = 'translateX(-50%) translateY(0)';
    }

    requestAnimationFrame(()=>{
      const r = menu.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;

      if (r.left < PAD){
        // Pin to left edge of trigger
        menu.style.left = '0';
        menu.style.right = 'auto';
        menu.style.transform = 'translateY(8px)';
      } else if (r.right > vw - PAD){
        // Pin to right edge of trigger
        menu.style.left = 'auto';
        menu.style.right = '0';
        menu.style.transform = 'translateY(8px)';
      }

      // If open/hovered, lift to Y=0 for the shown state
      if (item.classList.contains('is-open') || item.matches(':hover') || item.matches(':focus-within')){
        if (menu.style.transform.includes('translateY(8px)')){
          menu.style.transform = menu.style.transform.replace('translateY(8px)', 'translateY(0)');
        }
      }

      if (wasHidden){
        menu.style.removeProperty('visibility');
        menu.style.removeProperty('opacity');
        menu.style.removeProperty('pointer-events');
      }
    });
  };

  // Re-clamp on resize
  window.addEventListener('resize', ()=>{
    root.querySelectorAll('.cnav__item.has-children').forEach((item)=> window.clampMenu(item));
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow-events"] && !Shopify.designMode) return;
  try {
    
/**
 * Hero Slider + Events — no Liquid in JS; Theme Editor safe.
 */
(function () {
  function log(){ try{ console.log('[HeroSlider]', ...arguments);}catch(e){} }
  function err(){ try{ console.error('[HeroSlider]', ...arguments);}catch(e){} }

  function init(root){
    if (!root || root.__heroSliderInited) return;
    root.__heroSliderInited = true;

    const carousel = root.querySelector('.hero-carousel');
    const track    = root.querySelector('.hero-carousel__track');
    const slides   = Array.from(root.querySelectorAll('.hero-carousel__slide'));
    const prevBtn  = root.querySelector('[data-action="prev"]');
    const nextBtn  = root.querySelector('[data-action="next"]');

    if (!carousel || !track || slides.length === 0) {
      err('Missing pieces:', { carousel: !!carousel, track: !!track, slides: slides.length });
      return;
    }

    const autoplay = String(carousel.dataset.autoplay).toLowerCase() === 'true';
    const interval = parseInt(carousel.dataset.interval || '5000', 10) || 5000;

    let index = 0;
    let timer = null;

    function clamp(i){ return (i + slides.length) % slides.length; }

    function goTo(i, opts){
      const animate = !(opts && opts.animate === false);
      index = clamp(i);
      if (!animate){
        const prev = track.style.transition;
        track.style.transition = 'none';
        void track.offsetHeight;
        track.style.transform = `translateX(-${index * 100}%)`;
        track.style.transition = prev || '';
      } else {
        track.style.transform = `translateX(-${index * 100}%)`;
      }
      root.setAttribute('data-hero-index', String(index));
    }

    function start(){
      if (!autoplay || slides.length <= 1) return;
      clear();
      timer = setInterval(() => goTo(index + 1), interval);
    }
    function clear(){ if (timer){ clearInterval(timer); timer = null; } }
    function reset(){ clear(); start(); }

    // Init
    if (!getComputedStyle(track).transition || getComputedStyle(track).transition === 'all 0s ease 0s'){
      track.style.transition = 'transform 0.6s ease-in-out';
    }
    goTo(0, { animate:false });
    start();

    // Controls
    prevBtn && prevBtn.addEventListener('click', () => { goTo(index - 1); reset(); });
    nextBtn && nextBtn.addEventListener('click', () => { goTo(index + 1); reset(); });

    // Pause on hover / focus
    carousel.addEventListener('mouseenter', clear);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin',  clear);
    carousel.addEventListener('focusout', start);

    // Keep position on resize
    window.addEventListener('resize', () => { goTo(index, { animate:false }); });

    root.classList.add('hero-slider--initialized');
    log('initialized', { slides: slides.length, autoplay, interval });
  }

  function bootAll(){
    document.querySelectorAll('.hero-se-section[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootAll, { once:true });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    const el = e.target && e.target.querySelector('.hero-se-section[data-section-id]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
